import React from 'react';

import { XomicsSelect } from './parts';
import { languageLabel } from './siteWords';

// The language a website page's words are shown and written in: the same
// dropdown at the end of the toolbar of every page that has one.
export default function SiteLanguage({ label, value, languages, onChange, disabled = false }) {
  return (
    <XomicsSelect className="xo-toolbar-choice" aria-label={label} value={value} disabled={disabled}
      onChange={(event) => onChange(event.target.value)}>
      {languages.map((entry) => <option key={entry.code} value={entry.code}>{languageLabel(entry)}</option>)}
    </XomicsSelect>
  );
}
